import { httpGet, httpPatch, httpDelete } from '@/services/http';
import type { Application } from '@/utils/dataStore';

/** GET /api/admin/applications */
export function apiGetApplications(): Promise<Application[]> {
  return httpGet<Application[]>('/admin/applications');
}

/** PATCH /api/admin/applications/:id */
export function apiUpdateApplication(id: string, data: Partial<Application>): Promise<Application> {
  return httpPatch<Application>(`/admin/applications/${id}`, data);
}

/** DELETE /api/admin/applications/:id */
export function apiDeleteApplication(id: string): Promise<void> {
  return httpDelete(`/admin/applications/${id}`);
}

/** PATCH /api/admin/applications/batch-approve */
export function apiBatchApproveApplication(ids: string[]): Promise<void> {
  return httpPatch('/admin/applications/batch-approve', { ids });
}

/** PATCH /api/admin/applications/batch-reject */
export function apiBatchRejectApplication(ids: string[]): Promise<void> {
  return httpPatch('/admin/applications/batch-reject', { ids });
}
